export default __webpack_public_path__ + "static/media/cognito-header.25ea93a1.png";